import "./JourneyProgress.scss";
import { FC } from "react";
import { useSelector } from "react-redux";

import ProgressBar from "components/ProgressBar/ProgressBar";
import { getJourneyProgress } from "store/selectors";

import { isNumber } from "lodash-es";

const JourneyProgress: FC = () => {
  const {
    shouldDisplayProgress,
    percentOverride,
    percentage: calculatedPercentage,
  } = useSelector(getJourneyProgress);

  const displayPercentage = isNumber(percentOverride) ? percentOverride : calculatedPercentage || 0;

  return (
    <>
      {shouldDisplayProgress ? (
        <ProgressBar
          className="journey-progress"
          percentage={displayPercentage}
          showInitialProgress
        />
      ) : null}
    </>
  );
};

export default JourneyProgress;
